import GmDystoPunks from "../../assets/GM_DYSTOPUNKS.png";
import "./CredsBurn.scss";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context";
import Navbar from "../Navbar";
import useProvider from "../../hooks/useProvider";
import { BigNumber, ethers } from "ethers";
import CONTRACT_INFO, { CREDS_ABI, CREDS_ADDRESS } from "../../ContractInfo";

const CredsBurn = () => {
  const { wallet } = useContext(AppContext);
  const [chainId, setChainId] = useState<Number>(
    CONTRACT_INFO[window.chain].chainId || 1
  );
  const [balance, setBalance] = useState(0);
  const [burnt, setBurnt] = useState(false);
  const [totalBurnt, setTotalBurnt] = useState(0);
  const isEth = chainId === 1;
  const gmsRef = useContext(AppContext).refs?.gms;
  const provider = useProvider(1);
  const contract = provider
    ? new ethers.Contract(CREDS_ADDRESS, CREDS_ABI, provider.getSigner())
    : undefined;

  const fetchBalance = async () => {
    const balance = await contract?.balanceOf(wallet);
    setBalance(Number(ethers.utils.formatEther(balance)));
  };

  const fetchTotalBurnt = async () => {
    setTotalBurnt(
      Number(
        ethers.utils.formatEther(
          await contract?.balanceOf(
            "0x000000000000000000000000000000000000dead"
          )
        )
      )
    );
  };

  useEffect(() => {
    fetchBalance();
    fetchTotalBurnt();
  }, [contract]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setChainId(Number(window.ethereum.networkVersion) || 0);
    window.ethereum?.on("networkChanged", async (newChainId: Number) => {
      setChainId(newChainId);
    });
  }, [window.ethereum.networkVersion]); // eslint-disable-line react-hooks/exhaustive-deps

  const burn = async (count: BigNumber) => {
    await contract?.burn(count);
    setBurnt(true);
  };

  return (
    <>
      <Navbar />
      <div className="main-content" ref={gmsRef}>
        <div className="columns">
          <div className="column is-1"></div>
          <div className="gm-body column is-10">
            <img src={GmDystoPunks} className="coffee-image" alt="gm-badge" />
            <div className="gm-card ">
              <div className="gm-title">Exclusive</div>
              <div className="gm-title">DystoPunks GM Claim</div>
              <div className="card-body">
                Gms are our soulbound nfts that reward our early supporters. For
                a limited amount of time, users can redeem exclusive GM tokens
                with their own design, higher number of points and special place
                for the future in our ecosystem.
              </div>
              <br />
              <div className="claim-hint">
                Burn 777 $CREDS for a 5 point GM or 2,777 for a 20 point GM
              </div>
              <br />
              <div className="creds-balance">
                You currently have {balance} $CREDS
              </div>
              <br />
              <div className="claim-hint">
                Total $CREDS burnt: {totalBurnt.toLocaleString()}
              </div>
              <br />
              <button
                className="button is-primary mb-6"
                id="cred-burn-button"
                onClick={() => burn(BigNumber.from("777000000000000000000"))}
              >
                Burn 777
              </button>
              <button
                className="button is-primary mb-6"
                id="cred-burn-button-1"
                onClick={() => burn(BigNumber.from("2777000000000000000000"))}
              >
                Burn 2,777
              </button>
            </div>
          </div>
          <div className="column is-1"></div>
        </div>

        <div className={`modal ${!isEth ? "is-active" : ""}`}>
          <div className="modal-background" />
          <div className="modal-card">
            <header className="modal-card-head"></header>
            <section className="modal-card-body">
              <div>
                $CREDS exist on ETH mainnet. Please switch to mainnet to be able
                to burn your $CREDS. Then check back in later to be able to
                claim your exclusive DystoPunks GM token.
              </div>
            </section>
          </div>
        </div>
        <div className={`modal ${burnt ? "is-active" : ""}`}>
          <div className="modal-background" />
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Burning...</p>
              <button
                className="delete"
                aria-label="close"
                onClick={() => setBurnt(false)}
              ></button>
            </header>
            <section className="modal-card-body">
              <div className="claim-hint">
                Check back on {new Date(1683138588000).toLocaleString()} to
                claim your Exclusive DystoPunk GM! Or burn some more 👀
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CredsBurn;
